import { render, staticRenderFns } from "./McrFormB1.vue?vue&type=template&id=d81d5ce8"
import script from "./McrFormB1.vue?vue&type=script&lang=js"
export * from "./McrFormB1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports